import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist({
  key: 'digital-facility-atom-persist', // this key is using to store data in local storage
  storage: sessionStorage, // configure which storage will be used to store the data
  converter: JSON // configure how values will be serialized/deserialized in storage
})

export default persistAtom;